import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer.js'
import Slider from "react-slick"
import ProductTabs from '../../components/ProductTabs'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';

const HydratedLimePage = () => {

    const productData = {
        description: [
            "Hydrated Lime, also known as Calcium Hydroxide [Ca(OH)₂], is a versatile alkaline compound produced by slaking quicklime with water. It is widely used in construction, water treatment, chemical manufacturing, and environmental applications.",
            "Available in powder form with high purity and consistent quality for industrial and commercial applications.",
            "• Bags: typically 25 kg or 50 kg multi-wall paper bags with polyethylene liner for moisture protection — ideal for construction and industrial use.",
            "• Jumbo bags (FIBC): 500 kg to 1000 kg bulk bags for large-scale operations and efficient handling.",
            "• Bulk delivery: available in bulk tankers or pneumatic trucks for high-volume industrial requirements.",
            "• Silos and containers: for long-term storage at customer sites with automated dispensing systems.",
            "• Packing & labeling: all packages supplied with technical specifications, safety data sheets (SDS), and proper handling instructions. Moisture-resistant packaging ensures product stability during storage and transport."
        ],
        applications: [
            {
                id: 1,
                title: "Water & Wastewater Treatment",
                description: "Hydrated Lime is extensively used for pH adjustment, softening, coagulation, and neutralization in municipal and industrial water treatment plants. It effectively removes impurities and heavy metals.",
                image: "/images/products/hydrated-lime/water.jpg"
            },
            {
                id: 2,
                title: "Construction & Building Materials",
                description: "Essential component in mortar, plaster, and lime-based paints. Used for soil stabilization, road construction, and as a binding agent in masonry work and building restoration projects.",
                image: "/images/products/hydrated-lime/construction.jpg"
            },
            {
                id: 3,
                title: "Flue Gas Treatment & Air Pollution Control",
                description: "Used in dry and wet scrubbing systems to remove sulfur dioxide (SO₂) and acid gases from industrial emissions, power plants, and waste incinerators for environmental compliance.",
                image: "/images/products/hydrated-lime/fuel.jpg"
            },
            {
                id: 4,
                title: "Chemical Manufacturing & Industrial Processes",
                description: "Key raw material in production of calcium-based chemicals, pH control in chemical processes, neutralization of acidic waste, and manufacturing of paper, sugar, and various industrial products.",
                image: "/images/products/hydrated-lime/chemical.jpg"
            }
        ]
    };

    return (
        <Fragment>
            <SEO title={seoData.hydratedLime.title} description={seoData.hydratedLime.description} keywords={seoData.hydratedLime.keywords} />
            <Navbar/>
            <PageTitle pageTitle="Hydrated Lime" pagesub="Hydrated Lime" parentPage="Products" parentLink="#" />
            <div className="team-pg-area product-page-section">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <Slider dots={true} arrows={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                                        <div className="image-box">
                                            <img src='/images/products/hydrated-lime/hl1.jpg' alt="Hydrated Lime" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/hydrated-lime/hl2.jpg' alt="Hydrated Lime Powder" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/hydrated-lime/hl3.jpg' alt="Hydrated Lime Packaging" />
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>Hydrated Lime [Ca(OH)₂]</h2>
                                    <ul>
                                        <li>Chemical Formula: <span>Ca(OH)₂</span></li>
                                        <li>Purity: <span>90-96%</span></li>
                                        <li>Form: <span>Fine White Powder</span></li>
                                        <li>Packaging: <span>25kg, 50kg Bags, Bulk</span></li>
                                        <li>CAS Number: <span>1305-62-0</span></li>
                                        <li>Molecular Weight: <span>74.09 g/mol</span></li>
                                        <li>pH Level: <span>12.4 (Alkaline)</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProductTabs product={productData} />
                </div>
            </div>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default HydratedLimePage;
